import { render, staticRenderFns } from "./UserListSchoolDashboard.vue?vue&type=template&id=58b92d2d&scoped=true"
import script from "./UserListSchoolDashboard.vue?vue&type=script&lang=js"
export * from "./UserListSchoolDashboard.vue?vue&type=script&lang=js"
import style0 from "./UserListSchoolDashboard.vue?vue&type=style&index=0&id=58b92d2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b92d2d",
  null
  
)

export default component.exports